import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WhatIsGTBuySpreadsheet from "../pages/blog/what-is-gtbuy-spreadsheet/page";
import GTBuyVsKakobuy from "../pages/blog/gtbuy-vs-kakobuy/page";
import GTBuyVsSuperbuy from "../pages/blog/gtbuy-vs-superbuy/page";
import BestSourcingTools from "../pages/blog/best-sourcing-tools/page";
import ImproveProfitMargins from "../pages/blog/improve-profit-margins/page";
import HowToUseGTBuy from "../pages/blog/how-to-use-gtbuy/page";
import DropshippingSourcingSystem from "../pages/blog/dropshipping-sourcing-system/page";
import WhyUseSpreadsheetSourcing from "../pages/blog/why-use-spreadsheet-sourcing/page";
import ReduceSourcingCosts from "../pages/blog/reduce-sourcing-costs/page";
import GTBuySpreadsheetReview from "../pages/blog/gtbuy-spreadsheet-review/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-gtbuy-spreadsheet",
    element: <WhatIsGTBuySpreadsheet />,
  },
  {
    path: "/gtbuy-vs-kakobuy",
    element: <GTBuyVsKakobuy />,
  },
  {
    path: "/gtbuy-vs-superbuy",
    element: <GTBuyVsSuperbuy />,
  },
  {
    path: "/best-sourcing-tools",
    element: <BestSourcingTools />,
  },
  {
    path: "/improve-profit-margins",
    element: <ImproveProfitMargins />,
  },
  {
    path: "/how-to-use-gtbuy",
    element: <HowToUseGTBuy />,
  },
  {
    path: "/dropshipping-sourcing-system",
    element: <DropshippingSourcingSystem />,
  },
  {
    path: "/why-use-spreadsheet-sourcing",
    element: <WhyUseSpreadsheetSourcing />,
  },
  {
    path: "/reduce-sourcing-costs",
    element: <ReduceSourcingCosts />,
  },
  {
    path: "/gtbuy-spreadsheet-review",
    element: <GTBuySpreadsheetReview />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;